module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("I am grateful for the dozens of professionals, parents, and children who shared their insight, expertise, and personal stories. A few of the professionals I am indebted to include Ashley Solomon, PsyD ("), _c('em', [_c('a', {
    attrs: {
      "href": "http://www.nourishing-the-soul.com",
      "target": "_blank"
    }
  }, [_vm._v("www.nourishing-the-soul.com")])]), _vm._v("); "), _c('br'), _vm._v("Margarita Tartakovsky, MS ("), _c('em', [_c('a', {
    attrs: {
      "href": "http://blogs.psychcentral.com/weightless",
      "target": "_blank"
    }
  }, [_vm._v("http://blogs.psychcentral.com/weightless")])]), _vm._v("); Rosie Molinary ("), _c('em', [_c('a', {
    attrs: {
      "href": "http://www.rosiemolinary.com",
      "target": "_blank"
    }
  }, [_vm._v("www.rosiemolinary.com")])]), _vm._v("), author "), _c('br'), _vm._v("of "), _c('em', [_vm._v("Beautiful You: A Daily Guide to Radical Self-Acceptance")]), _vm._v(" and "), _c('em', [_vm._v("Hijas Americanas: Beauty, Body Image, and Growing Up Latina")]), _vm._v("; Diane Keddy, MS, RD, FAED ("), _c('em', [_c('a', {
    attrs: {
      "href": "http://www.dianekeddy.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dianekeddy.com")])]), _vm._v("); "), _c('br'), _vm._v("Katja Rowell, MD ("), _c('em', [_c('a', {
    attrs: {
      "href": "http://www.familyfeedingdynamics.com",
      "target": "_blank"
    }
  }, [_vm._v("www.familyfeedingdynamics.com")])]), _vm._v("); and "), _c('br'), _vm._v("Laura Stern ("), _c('em', [_c('a', {
    attrs: {
      "href": "http://www.laurenlazarstern.com",
      "target": "_blank"
    }
  }, [_vm._v("www.laurenlazarstern.com")])]), _vm._v("), author of "), _c('em', [_vm._v("The Slender Trap: A Food and Body Workbook")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32cf4da4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ack.vue
// module id = 75
// module chunks = 0